import { AnyAction } from 'redux';

interface UpdateUser {
    loading: boolean;
}

const initialState: UpdateUser = {
    loading: false,
};
export const UpdateUser = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_UPDATE_USER':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
